import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "AI等級",
    isNumber: true,
    isSum: true,
  },
];

export const AILevel = {
  label: "AI等級(-1,-2.5)",
  key: "AILevel",
  path: "BoneMuscleCare/AILevel",
  api: "TCS_V_AILevel02V",
  render: (options) => <Diagram.BoneMuscleCare.AILevel {...options} />,
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "部位",
      field: "部位",
      header: "",
    },
  ],
  filterColumns: [{ key: "篩檢日期", type: "date" }],
  levelColumns,
  columns: [],
};
